import { render, staticRenderFns } from "./squintmetrics.vue?vue&type=template&id=51bdbc81&scoped=true&v-once=true"
import script from "./squintmetrics.vue?vue&type=script&lang=js"
export * from "./squintmetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bdbc81",
  null
  
)

export default component.exports